import { configureStore } from '@reduxjs/toolkit';
import authReducer from './redux/authSlice';
import doctorReducer from './redux/doctorSlice';
import patientReducer from './redux/patientSlice';
import appointmentReducer from './redux/appointmentSlice';
import blockingReducer from "./redux/blockingSlice";
import adminReducer from './redux/adminSlice';
import dashboardReducer from './redux/dashboardSlice';
import reportsReducer from './redux/reportsSlice';
import rulesReducer from './redux/rulesSlice';
import masterReducer from './redux/masterSlice';
import translationReducer from './redux/translationSlice';
import customPriceReducer from './redux/customPriceSlice';
import ctgReducer from './redux/ctgSlice';
import featureReducer from './redux/featureSlice';
import medicineReducer from './redux/medicineSlice';
import prescriptionFieldReducer from './redux/prescriptionFieldSlice';
import paymentReducer from './redux/paymentSlice';
import subscriptionReducer from './redux/subscriptionSlice';
import contactInquiryReducer from './redux/contactInquirySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    doctor: doctorReducer,
    patient: patientReducer,
    appointment: appointmentReducer,
    blocking: blockingReducer,
    admin: adminReducer,
    dashboard: dashboardReducer,
    reports: reportsReducer,
    rules: rulesReducer,
    master: masterReducer,
    translation: translationReducer,
    customPrice: customPriceReducer,
    ctg: ctgReducer,
    feature: featureReducer,
    medicine: medicineReducer,
    prescriptionField: prescriptionFieldReducer,
    payment: paymentReducer,
    subscription: subscriptionReducer,
    contactInquiry: contactInquiryReducer,
  },
});
